import {MemoizedSelector} from '@ngrx/store/src/selector';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {distinctUntilChanged, filter} from 'rxjs/operators';
import {LoadableState} from '../ngrx/states/loadable-state';
import {LoadableResult} from './loadable-result';
import {untilDestroyed} from '@ngneat/until-destroy';

export function whenLoaded<R extends LoadableResult>(caller: any, store: Store<LoadableState>, selector: MemoizedSelector<LoadableState, R>): Observable<R> {
  return store
    .pipe(untilDestroyed(caller))
    .pipe(select(selector))
    .pipe(distinctUntilChanged())
    .pipe(filter(x => x && x.ready));
}
